var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAboutask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.336,
    height: 17.336,
    viewBox: "0 0 17.336 17.336",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_help_922772",
    transform: "translate(-14 -14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1646",
    "data-name": "Group 1646",
    transform: "translate(14 14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M22.668,14a8.668,8.668,0,1,0,8.668,8.668A8.676,8.676,0,0,0,22.668,14Zm0,.963a7.705,7.705,0,1,1-7.705,7.705A7.7,7.7,0,0,1,22.668,14.963Zm0,2.889a2.924,2.924,0,0,0-2.889,2.889.482.482,0,1,0,.963,0,1.926,1.926,0,1,1,3.852,0,2.289,2.289,0,0,1-1.038,1.806,6.74,6.74,0,0,0-.9.91,2.238,2.238,0,0,0-.474,1.354v.263a.482.482,0,1,0,.963,0v-.263a1.192,1.192,0,0,1,.278-.775,6.41,6.41,0,0,1,.775-.775,3.336,3.336,0,0,0,1.354-2.521s0,0,0-.008A2.924,2.924,0,0,0,22.668,17.853Zm0,8.427a.722.722,0,1,0,.722.722A.722.722,0,0,0,22.668,26.28Z",
    transform: "translate(-14 -14)",
    fill: "#373334"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutask);
export default __webpack_public_path__ + "static/media/aboutask.4b88012ad4957a26a9d846167d75477c.svg";
export { ForwardRef as ReactComponent };